import React, {useCallback} from 'react';
import {connect} from 'react-redux';

import {FilterControlsV2} from '@ey/canvascoreservices/FiltersControls';

import {labels} from '../../../../../util/utils';
import Utility from '../../../../../util/utilityfunctions';

import * as FilterContacts from '../../../../../actions/ContactDB';
import * as FilterActions from '../../../../../actions/Filter/FilterActions';
import * as ContactDBFilterActions from '../../../../../actions/ContactDB/ContactDBFilterActions';

const ContactsDBFilterControls = ({
	actions,
	filterData,
	userPreferences,
	filterConfiguration,
	state,
	dispatch,
	numberOfChips,
	_syncQueryString
}) => {
	const handleOnClearFilters = () => {
		actions.clearContactDBFilters();
		actions.setContacts(null);
	};

	const handleOnDisableFilter = useCallback(
		(filter, value) => {
			actions.setContactDBFilter(filter.name, value);
			actions.setContacts({name: filter.name, value: value});
		},
		[actions]
	);

	const handleSetState = useCallback(
		(callback) => {
			dispatch({
				type: 'state/set',
				value: {
					filters: callback(state.filters)
				}
			});
		},
		[state.filters, dispatch]
	);

	return (
		<FilterControlsV2
			_syncQueryString={_syncQueryString}
			filterKey={filterConfiguration.key}
			state={state.filters ? state.filters : null}
			filterNotAvailableText={''}
			setState={handleSetState}
			count={numberOfChips}
			dropdownPlacement="bottom-right"
			store={filterData}
			actions={actions}
			userPreferences={userPreferences}
			clearHover={labels.clearHoverText}
			clearAll={labels.contactClearAll}
			more={labels.contactShowMoreFilters}
			onClearFilters={handleOnClearFilters}
			onDisableFilter={handleOnDisableFilter}
			theme={Utility.getMotifTheme()}
		/>
	);
};

const mapState = (state, ownProps) => {
	return {
		filterData: state.filterData[ownProps.filterConfiguration.key],
		contactDBFilters: state.contactDBFilters,
		userPreferences: state.userPreferences
	};
};

const mapDispatch = (dispatch) => {
	return {
		actions: {
			clearContactDBFilters: (initialState) => dispatch(ContactDBFilterActions.clearContactDBFilters(initialState)),

			setContacts: (filter) => dispatch(FilterContacts.filterContacts({filters: filter})),

			setContactDBFilter: (filterItemName, value) =>
				dispatch(ContactDBFilterActions.setContactDBFilter(filterItemName, value)),

			getFilterEntities: (filterKey, filterName, entityType, entityFilter) =>
				dispatch(FilterActions.getFilterEntities(filterKey, filterName, entityType, entityFilter))
		}
	};
};

export default connect(mapState, mapDispatch)(ContactsDBFilterControls);
